interface LayoutProps {
  children: React.ReactNode
}

export const Layout = ({ children }: LayoutProps) => {
  return <div className='min-h-screen w-full bg-background'>{children}</div>
}
